import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';

const ProtectedRoute = ({ adminOnly = false, children }) => {
  const { isAuthenticated, isLoading, user } = useContext(AuthContext);
  const location = useLocation();
  const { t } = useTranslation();

  if (isLoading) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-light-bg text-gray-700">
            {t('auth_checking')}
        </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;